import { v4 as uuid } from "uuid";

import { IBriefResource } from "../../briefs";
import { EntityTypes } from "../../EntityTypes";
import { ILanguageResource } from "../../languages";
import { IProfessionalSituationResource } from "../../professional-situations";
import { ISkillResource } from "../../skills";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";

export interface IProfessionalSituationCreateMutationParameters {
    uuid: string;
    title: string;
    targetedDomain: string;
    problematic: string;
    description: string;
    language: RelationalValue<ILanguageResource>;
    skills: RelationalValue<ISkillResource>[];
    briefs?: RelationalValue<IBriefResource>[];
}

export type IProfessionalSituationCreateMutationResult = IProfessionalSituationResource;

export const professionalSituationCreateMutation: IApiMutationFunction<
    IProfessionalSituationCreateMutationParameters
> = ({ language, skills, briefs, uuid: providedUuid, ...data }) => ({
    method: "POST",
    url: "/professional_situations",
    data: {
        ...data,
        uuid: providedUuid ?? uuid(),
        language: mapRelationalValueAsIRI(EntityTypes.LANGUAGE, language),
        skills: skills.map(skill => mapRelationalValueAsIRI(EntityTypes.SKILL, skill)),
        briefs: briefs?.map(brief => mapRelationalValueAsIRI(EntityTypes.BRIEF, brief)),
    },
});

export const useProfessionalSituationCreateMutation = createApiMutationHook<
    IProfessionalSituationCreateMutationParameters,
    IProfessionalSituationCreateMutationResult
>(professionalSituationCreateMutation);
